import { Text, Box, TooltipRenderer } from 'braid-design-system';
import type { ReactElement, ReactNode } from 'react';

import { noop } from '../../type';
import TextButton from '../TextButton';

import * as styles from './index.css';

interface IconWithTextProps {
  icon: ReactElement;
  label: ReactNode;
  testId?: string;
  disabled?: boolean;
}

interface Props extends IconWithTextProps {
  onClick: () => void;
  tooltipText?: string;
}

export const IconWithText = ({
  icon,
  label,
  testId,
  disabled,
}: IconWithTextProps) => (
  <Box
    component="span"
    display="flex"
    alignItems="center"
    className={{ [styles.disabledWrapper]: disabled }}
    data-testid={testId}
  >
    {icon}
    <Box paddingLeft="small" component="span">
      {label}
    </Box>
  </Box>
);

const IconTextLink = ({
  label,
  icon,
  onClick = noop,
  disabled = false,
  tooltipText,
  testId,
}: Props) => {
  const tooltipContent = <Text baseline={false}>{tooltipText}</Text>;

  return (
    <Box display="inlineBlock">
      {disabled ? (
        <TooltipRenderer
          id={`tooltip-icontextlink-${label}`}
          placement="bottom"
          tooltip={tooltipContent}
        >
          {({ triggerProps }) => (
            <Box {...triggerProps}>
              <Text tone="secondary" baseline={false}>
                <IconWithText
                  icon={icon}
                  label={label}
                  disabled={disabled}
                  testId={testId}
                />
              </Text>
            </Box>
          )}
        </TooltipRenderer>
      ) : (
        <Text tone="neutral" baseline={false}>
          <TextButton onClick={onClick}>
            <IconWithText
              icon={icon}
              label={label}
              disabled={disabled}
              testId={testId}
            />
          </TextButton>
        </Text>
      )}
    </Box>
  );
};

export default IconTextLink;
